/**
 * 파일 다운로드 (File 객체 또는 URL)
 */
export const downloadFile = (file: File): void => {
  const url = URL.createObjectURL(file);
  const a = document.createElement("a");
  a.href = url;
  a.download = file.name;
  a.click();
  URL.revokeObjectURL(url);
};

export const downloadFromUrl = (url: string, fileName?: string): void => {
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName || url.split("/").pop() || "download";
  a.target = "_blank";
  a.click();
};

/**
 * 파일 크기 포맷
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return bytes + "B";
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + "KB";
  if (bytes < 1024 * 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(1) + "MB";
  return (bytes / (1024 * 1024 * 1024)).toFixed(2) + "GB";
};

/**
 * 파일 확장자 추출
 */
export const getFileExt = (name: string): string => {
  return name.split(".").pop()?.toLowerCase() ?? "";
};

/**
 * 위험 확장자 목록
 */
export const BLOCKED_EXTENSIONS = [
  "exe", "msi", "bat", "cmd", "scr", "dll", "js", "vbs", "ps1", "apk", "sh", "com",
];

/**
 * 허용 확장자 목록 (강의 자료)
 */
export const ALLOWED_MATERIAL_EXTENSIONS = [
  "pdf", "hwp", "hwpx", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt",
  "jpg", "jpeg", "png", "gif",
  "mp4", "mov", "avi",
  "zip", "rar", "7z",
];

/**
 * 파일 유효성 검사
 */
export const isBlockedFile = (name: string): boolean => {
  return BLOCKED_EXTENSIONS.includes(getFileExt(name));
};

export const isAllowedMaterial = (name: string): boolean => {
  return ALLOWED_MATERIAL_EXTENSIONS.includes(getFileExt(name));
};
